import { useRouteError, Link } from "react-router-dom";
import { Container, Title, Text, Button, Stack, Paper } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";

export default function ErrorPage() {
  const error = useRouteError();
  return (
    <Container size="sm" py="xl">
      <Paper p="xl" withBorder>
        <Stack align="center" gap="md">
          <IconAlertTriangle size={48} color="var(--mantine-color-red-6)" />
          <Title order={3}>Something went wrong</Title>
          <Text c="dimmed" ta="center">
            {error instanceof Error ? error.message : "An unexpected error occurred."}
          </Text>
          <Button component={Link} to="/">Go Home</Button>
        </Stack>
      </Paper>
    </Container>
  );
}
